import React from "react";
import LoginContainer from "../containers/Login";

const Login = () => {
  return <LoginContainer />;
};

export default Login;
